import React from 'react';
import { useParams } from 'react-router-dom';

export default (WrappedComponent: React.ComponentType<any>) =>
  function ConnectUrlSite(props: any) {
    const { urlSite, pageId } = useParams();
    return <WrappedComponent {...props} urlSite={urlSite} pageId={pageId} />;
  };
